import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import useAnalytics from 'utils/useAnalytics/useAnalytics';

const TrackUTMReferrals = () => {
  const { logEvent } = useAnalytics();

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const utmReferral = searchParams.get('utm_referral');
    const source = searchParams.get('source');

    if (utmReferral) {
      logEvent('utm_referral', { utm_referral: utmReferral });
      searchParams.delete('utm_referral');
    }

    if (source) {
      logEvent('source', { source });
      searchParams.delete('source');
    }

    if (utmReferral || source) {
      setSearchParams(searchParams);
    }
  }, [logEvent, searchParams, setSearchParams]);

  return null;
};

export default TrackUTMReferrals;
